import React, { useEffect, useState } from 'react';
import {
  Widget,
  FormSelect,
  MasterDetailForm,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  FormInput,
  Button,
  Table,
  ColumnProps,
  FormSubmitButton,
  FormRadio,
} from '@digital/ui';
import { Collapse, Icon, Radio } from 'antd';
import { PaginationConfig } from 'antd/lib/pagination';
import { CrfProjeto, CrfProjetoPacote } from '@app/api/crf/crfProjeto';
import { getAllCrfContaContabil, ICrfContaContabilAgrupador } from '@app/api/crf/contaContabil';
import { createCrfContaContabilCc, ICreateCrfContaContabilCc } from '@app/api/crf/crfContaContabilCc';
import { CrfAcronimoAgrupador } from '@app/api/crf/acronimo/Agrupador/acronimosAgrupador';
import { OrcamentoAcronimoAgrupador } from '@app/api/crf/acronimo/Agrupador/tipoAgrupador';

interface FormProjetoProps {
  acronimos: { text: string; value: string }[] | undefined;
  projetoPa: CrfProjetoPacote[];
  handleUpdate: (record: OrcamentoAcronimoAgrupador) => void;
  onUpdate: () => void;
  crfprojetoSelecionado: CrfProjeto | undefined;
}

const { Panel } = Collapse;

const FormProjetoAgrupador = (props: FormProjetoProps) => {
  const { acronimos, projetoPa, handleUpdate, onUpdate, crfprojetoSelecionado } = props;
  const [codigoContaContabil, setCodigoContaContabil] = useState('');
  const [codigoAgrupador, setCodigoAgrupador] = useState('');
  const [contasContabeis, setContasContabeis] = useState<ICrfContaContabilAgrupador[]>([]);
  const [contasContabeisFiltradas, setContasContabeisFiltradas] = useState<ICrfContaContabilAgrupador[]>([]);
  const [contaContabilSelecionada, setContaContabilSelecionada] = useState('');

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'contaContabilCodigo',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'contaContabilNome',
        width: '35%',
      },
      {
        title: 'Situação',
        dataIndex: 'situacao',
        width: '1%',
      },
      {
        title: 'RFA',
        dataIndex: 'possuiRfa',
        width: '1%',
      },
      {
        title: 'Acrônimo',
        dataIndex: 'acronimoId',
        key: 'acronimoId',
        options: acronimos,
        width: '7%',
        render: (_: string, record: CrfAcronimoAgrupador) => {
          const option = acronimos && acronimos.find(f => f.value === record.acronimoId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="acronimoId" options={acronimos} required disabled={false} allowClear />,
      },
      {
        title: 'Data',
        dataIndex: 'ultimaAtualizacao',
        width: '15%',
      },
      {
        title: 'Responsável',
        dataIndex: 'matriculaResponsavel',
        width: '25%',
      },
    ] as InlineEditColumnProps<CrfProjetoPacote>[];
  };

  const columnsContasContabeis = () => {
    const columns: ColumnProps<ICrfContaContabilAgrupador>[] = [];

    columns.push({
      title: '',
      dataIndex: 'contaContabilId',
      render: (_: string, record: ICrfContaContabilAgrupador) => (
        <Radio
          name="ccId"
          checked={record.contaContabilId === contaContabilSelecionada}
          onClick={() => setContaContabilSelecionada(record.contaContabilId)}
        />
      ),
      width: '1%',
    });

    columns.push({
      title: 'Conta Contábil',
      dataIndex: 'codigo',
      width: '10%',
    });

    columns.push({
      title: 'Agrupador',
      dataIndex: 'codigoAgrupador',
      width: '10%',
    });

    columns.push({
      title: 'Descrição',
      dataIndex: 'descricao',
    });

    return columns;
  };

  useEffect(() => {
    getContasContabeis();
  }, []);

  const pesquisarTable = () => {
    const filtrados = contasContabeis.filter(f => {
      let resultAgrupador = true;
      let resultContaContabil = true;
      if (codigoAgrupador.length > 0)
        resultAgrupador = f.codigoAgrupador
          ? f.codigoAgrupador.toLowerCase().includes(codigoAgrupador.toLowerCase())
          : false;
      if (codigoContaContabil.length > 0)
        resultContaContabil = f.codigo.toString().includes(codigoContaContabil.toLowerCase());
      return resultAgrupador && resultContaContabil;
    });
    setContasContabeisFiltradas(filtrados);
  };

  const getContasContabeis = async () => {
    var result = await getAllCrfContaContabil();
    if (result) {
      setContasContabeisFiltradas(result);
      setContasContabeis(result);
    }
  };

  const handleClear = () => {
    getContasContabeis();
    setCodigoContaContabil('');
    setCodigoAgrupador('');
    setContaContabilSelecionada('');
  };

  const handleAdicionarLinha = async () => {
    if (crfprojetoSelecionado) {
      var result = await createCrfContaContabilCc({
        crfProjetoId: crfprojetoSelecionado.id,
        crfContaContabilId: contaContabilSelecionada,
      });
      if (result) {
        handleClear();
        onUpdate();
      }
    }
  };

  const codiguracaoPaginacao = {
    pageSize: 10
} as PaginationConfig;

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="LISTA DE AGRUPADORES DO PROJETO" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget actions={[]}>
              <Row>
                <InlineEditTable
                  rowKey="index"
                  columns={customColumns()}
                  updateItem={handleUpdate}
                  dataSource={projetoPa || []}  
                  pagination={codiguracaoPaginacao}
                  disablenotification={false}
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      <Collapse bordered={false} defaultActiveKey={['3']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="3" header="INSERIR AGRUPADOR" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                <Button key="clear" type="link" onClick={handleClear} title="cancelar" icon="commons-cancel" />,
                <FormSubmitButton
                  key="submit"
                  type="primary"
                  title="adicionar linha selecionada"
                  icon="data-add_row"
                  onClick={() => handleAdicionarLinha()}
                />,
              ]}>
              <Row>
                <FormInput
                  value={codigoContaContabil}
                  onChange={e => setCodigoContaContabil(e.currentTarget.value)}
                  name="codigoContaContabil"
                  label="Código Conta Contábil"
                  span={2}
                />
                <FormInput
                  value={codigoAgrupador}
                  onChange={e => setCodigoAgrupador(e.currentTarget.value)}
                  name="codigoAgrupador"
                  label="Código Agrupador"
                  span={2}
                />
                <Button title="Pesquisar" style={{ marginTop: '22px' }} onClick={() => pesquisarTable()} />
              </Row>
              <Row>
                <Table
                  columns={columnsContasContabeis()}
                  dataSource={contasContabeisFiltradas}
                  rowKey="contaContabilId"
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormProjetoAgrupador;
